import React from "react";
import PickerMultiBoxDetails from "./PickerMultiBoxDetails";
import { Button, message } from "antd";
import Scanner from "../BarcodeScanner/Scanner";
import { ScannerWrapper } from "./ToPickerMultiBoxLoop.style";
// import Quagga from "quagga";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { saveQuantityInBoxThunk } from "../../redux/PickerTO/Action";

class ToPickerMultiBoxLoop extends React.Component {
  state = {
    medQty: this.props.currentQty,
    qty: 0,
    pendingQuantity: this.props.pendingQuantity ?? 0,
    previousPickedQty:
      Number(this.props.currentQty) - Number(this.props.pendingQuantity) ?? 0,
    camera: false,
    boxNumber: this.props.boxNumber ?? "0",
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.boxNumber !== prevProps.boxNumber) {
      this.setState({
        boxNumber: this.props.boxNumber,
      });
    }

    if (
      this.props.currentQty != prevProps.currentQty ||
      this.props.pendingQuantity != prevProps.pendingQuantity ||
      this.props.productCode != prevProps.productCode
    ) {
      this.setState({
        medQty: this.props.currentQty,
        pendingQuantity: this.props.pendingQuantity ?? 0,
        previousPickedQty:
          Number(this.props.currentQty) - Number(this.props.pendingQuantity) ??
          0,
      });
    }
  };
  handlePicker = (qty) => {
    this.props.pageLoadToggle(true);
    this.props
      .saveQuantityInBoxThunk({
        access_token: this.props.access_token,
        data: {
          toNumber: this.props.toNumber ?? "0",
          boxNumber: this.state.boxNumber ?? "0",
          productCode: this.props.productCode ?? "",
          quantity: qty,
        },
      })
      .then(() => {
        this.props.pageLoadToggle(false);
        if (this.props.saveQuantityInBoxFailure) {
          message.error(this.props.saveQuantityInBoxFailure);
        } else {
          if (
            !this.props.saveQuantityInBoxSuccess?.partiallyPicked &&
            !this.props.saveQuantityInBoxSuccess?.lastMed
          ) {
            this.props.nextMedicine();
          } else if (this.props.saveQuantityInBoxSuccess?.partiallyPicked) {
            this.setState({
              pendingQuantity: this.props.saveQuantityInBoxSuccess
                ?.pendingQuantity,
              previousPickedQty:
                Number(this.props.currentQty) -
                Number(this.props.saveQuantityInBoxSuccess?.pendingQuantity),
              camera: true,
            });
          } else if (
            !this.props.saveQuantityInBoxSuccess?.partiallyPicked &&
            this.props.saveQuantityInBoxSuccess?.lastMed
          ) {
            this.props.handleLastMed();
          }
        }
      });
  };
  onDetect = (value) => {
    // Quagga.stop();
    message.success(`New box :${value} added successfully`);
    this.props.updateBoxNumber(value);
    this.setState({
      camera: false,
      boxNumber: value,
    });
    // this.props
    //   .saveQuantityInBoxThunk({
    //     access_token: this.props.access_token,
    //     data: {
    //       toNumber: this.props.toNumber ?? "0",
    //       boxNumber: this.state.boxNumber ?? "0",
    //       productCode: this.props.productCode ?? "",
    //     },
    //   })
    //   .then(() => {
    //     if (this.props.SaveQuantityDetailsFailure) {
    //       message.error(this.props.SaveQuantityDetailsFailure);
    //     } else {

    //     }
    //   });
  };
  render() {
    const { medQty, previousPickedQty } = this.state;
    return (
      <div>
        {this.state.camera ? (
          <ScannerWrapper>
            <div className="addBoxText">Add Another Box</div>
            {/* <Button
              onClick={() => {
                this.setState({
                  camera: false,
                });
                Quagga.stop();
              }}
            >
              Back
            </Button> */}
            <Scanner
              onDetected={(value) => {
                this.onDetect(value);
              }}
            />
          </ScannerWrapper>
        ) : (
          <div>
            <PickerMultiBoxDetails
              previousPickedQty={previousPickedQty}
              medQty={medQty}
              medName={this.props.medName}
              handlePicker={(qty) => this.handlePicker(qty)}
              pendingQuantity={this.state.pendingQuantity}
              boxNumber={this.state.boxNumber}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginInfo: state.authReducer,
    saveQuantityInBoxSuccess: state.pickerTOReducer.SaveQuantityDetailsSuccess,
    saveQuantityInBoxFailure: state.pickerTOReducer.SaveQuantityDetailsFailure,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    saveQuantityInBoxThunk,
  })(ToPickerMultiBoxLoop)
);
